export default __webpack_public_path__ + "static/media/lefteye.23507682.svg";